import { render, staticRenderFns } from "./MtipobultoFormHeader.vue?vue&type=template&id=ba09901a"
import script from "./MtipobultoFormHeader.vue?vue&type=script&lang=js"
export * from "./MtipobultoFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports